module.exports = __webpack_public_path__ + "img/1486109841.5353475d.jpg";